import { Carousel } from "react-bootstrap";
import { useGlobalContext } from "./context/globalContext";

const desktopBanners = [
  {
    src: "images/web-banner-02.png",
    alt: "Godrej Horizon desktop banner 1",
  },
  {
    src: "images/web-banner-01.png",
    alt: "Godrej Horizon desktop banner 2",
  },
];

const mobileBanners = [
  {
    src: "images/mobile-banner-02.png",
    alt: "Godrej Horizon mobile banner 1",
  },
  {
    src: "images/mobile-banner-01.png",
    alt: "Godrej Horizon mobile banner 2",
  },
];

const BannerCarousel = ({ banners, modalLabel }) => {
  const { handleShowModal } = useGlobalContext();

  return (
    <Carousel
      className="hero-carousel"
      controls={false}
      indicators={false}
      interval={3000}
      pause={false}
      touch
    >
      {banners.map((banner) => (
        <Carousel.Item key={banner.src}>
          <img
            onClick={() => handleShowModal(modalLabel)}
            height="100%"
            width="100%"
            className="d-block micro-main-slider-img ls-is-cached lazyloaded"
            src={banner.src}
            alt={banner.alt}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

const Hero = () => {
  return (
    <div id="home" className="section" style={{ padding: "0" }}>
      <div className="desktopview">
        <BannerCarousel banners={desktopBanners} modalLabel="Web Banner" />
      </div>
      <div className="mobileview">
        <BannerCarousel banners={mobileBanners} modalLabel="Mob Banner" />
      </div>
    </div>
  );
};

export default Hero;
